(function () {
  'use strict';

  var root = document.querySelector('[data-emit-support-center]');
  if (!root || root.dataset.emitSupportInitialized === 'true') return;
  root.dataset.emitSupportInitialized = 'true';

  var r = {
    systemGuide: '/pages/guide-led-lighting-system',
    stripGuide: '/pages/guide-led-strip-lighting',
    powerGuide: '/pages/power-drivers',
    dimmingGuide: '/pages/guide-led-dimming',
    wiringGuide: '/pages/guide-led-wiring-connections',
    planningGuide: '/pages/guide-led-planning',
    installationGuide: '/pages/guide-led-installations',
    ipGuide: '/pages/guide-led-ip-ratings-environment',
    troubleshootingGuide: '/pages/guide-led-troubleshooting',

    stripBuying: '/pages/how-to-buy-led-strip-lights',
    powerBuying: '/pages/how-to-buy-led-power-supplies',
    dimmingBuying: '/pages/how-to-buy-led-dimming-controls',

    wattage: '/pages/led-wattage-calculator',
    kit: '/pages/led-kit-builder',
    system: '/pages/led-system-builder',
    hub: '/pages/builders-selection-hub',
    productHub: '/pages/product-selection-hub',
    worksheet: '/pages/led-lighting-system-planning-worksheet',

    docs: '/pages/resourcedownloads',
    faq: '/pages/fqa',
    contact: '/pages/contact',
    catalog: '/pages/catalog-download',

    professionals: '/pages/lighting-power-professionals-hub',
    partners: '/pages/wholesale-registration-emit',

    projectPricing: '/pages/contact?inquiry=volume_quote',
    orderSupport: '/pages/contact?inquiry=order_support',
    amazonSupport: '/pages/contact?inquiry=amazon_support',

    amazonReturns: 'https://www.amazon.com/returns',
    returnsPolicy: '/policies/refund-policy',
    shippingPolicy: '/policies/shipping-policy',
    privacyPolicy: '/policies/privacy-policy',
    termsPolicy: '/policies/terms-of-service',

    orders: 'https://account.emitever.com/orders'
  };

  function d(label, title, copy, url, action, related) {
    return {
      label: label,
      title: title,
      copy: copy,
      url: url,
      action: action,
      related: related || []
    };
  }

  function q(id, label, dest) {
    return {
      id: id,
      label: label,
      destination: dest
    };
  }

  /* ---------------------------------------------------------
     SUPPORT PATH ROUTER
  --------------------------------------------------------- */

  var intents = {
    plan: {
      kicker: 'Plan a Project',
      title: 'What are you trying to figure out?',
      description: 'Start with the part of your project you need help planning.',
      questions: [
        q(
          'start-project',
          'I’m starting a new LED project',
          d(
            'Best starting point',
            'LED System Guide',
            'Understand the major parts of an LED lighting system and how they work together before choosing components.',
            r.systemGuide,
            'Start with the system guide',
            [
              ['Plan the complete system', r.system],
              ['Use the planning worksheet', r.worksheet],
              ['Browse product paths', r.productHub]
            ]
          )
        ),

        q(
          'power-size',
          'What size power supply do I need?',
          d(
            'Recommended tool',
            'LED Wattage Calculator',
            'Estimate the power requirement for your LED run before choosing a power supply or driver.',
            r.wattage,
            'Calculate power',
            [
              ['Power & Driver Guide', r.powerGuide],
              ['Power Supply Buying Guide', r.powerBuying]
            ]
          )
        ),

        q(
          'voltage',
          'What voltage should I use?',
          d(
            'Learn first',
            'LED Power & Driver Guide',
            'Learn how system voltage affects LED strips, power supplies, run planning, and component selection.',
            r.powerGuide,
            'Understand system voltage',
            [
              ['LED Strip Lighting Guide', r.stripGuide],
              ['Plan with the System Builder', r.system]
            ]
          )
        ),

        q(
          'runs',
          'How should I plan multiple LED runs?',
          d(
            'Planning resource',
            'LED System Planning Guide',
            'Plan runs, power locations, zones, and system layout before installation.',
            r.planningGuide,
            'Plan the system',
            [
              ['Planning Worksheet', r.worksheet],
              ['Wiring & Connections Guide', r.wiringGuide]
            ]
          )
        ),

        q(
          'environment',
          'Can I use this in a wet or outdoor location?',
          d(
            'Environment guide',
            'IP Ratings & Environment Guide',
            'Understand dry, damp, wet, and outdoor conditions before choosing products for the location.',
            r.ipGuide,
            'Check the environment',
            [
              ['Choose products', r.productHub],
              ['Contact project support', r.contact]
            ]
          )
        )
      ]
    },

    choose: {
      kicker: 'Choose Products',
      title: 'What do you need help choosing?',
      description: 'Start with the component or system decision you’re making.',
      questions: [
        q(
          'choose-strip',
          'LED strip lights',
          d(
            'Buying guide',
            'How to Buy LED Strip Lights',
            'Compare the important choices involved in selecting an LED strip for your project.',
            r.stripBuying,
            'Choose an LED strip',
            [
              ['LED Strip Lighting Guide', r.stripGuide],
              ['Browse product paths', r.productHub]
            ]
          )
        ),

        q(
          'choose-power',
          'Power supply or dimmable driver',
          d(
            'Buying guide',
            'How to Buy LED Power Supplies',
            'Choose the correct voltage, capacity, and power-supply type for your LED system.',
            r.powerBuying,
            'Choose power',
            [
              ['Wattage Calculator', r.wattage],
              ['Power & Driver Guide', r.powerGuide]
            ]
          )
        ),

        q(
          'choose-control',
          'Dimming or controls',
          d(
            'Buying guide',
            'How to Buy LED Dimming & Controls',
            'Choose a control approach that matches how you want to operate the lighting system.',
            r.dimmingBuying,
            'Choose controls',
            [
              ['Dimming & Controls Guide', r.dimmingGuide],
              ['System Builder', r.system]
            ]
          )
        ),

        q(
          'choose-system',
          'I’m not sure what components I need',
          d(
            'Recommended tool',
            'LED System Builder',
            'Plan the system as a whole instead of choosing each component independently.',
            r.system,
            'Build a system',
            [
              ['Choose Your Builder', r.hub],
              ['LED System Guide', r.systemGuide]
            ]
          )
        )
      ]
    },

    compatibility: {
      kicker: 'Check Compatibility',
      title: 'What are you trying to check?',
      description: 'Compatibility depends on voltage, load, control method, and the specific components being used.',
      questions: [
        q(
          'strip-power',
          'LED strip + power supply',
          d(
            'Check the fundamentals',
            'Start with voltage and power sizing',
            'The strip and power supply need matching system voltage, and the power supply needs enough capacity for the connected load.',
            r.powerGuide,
            'Review power compatibility',
            [
              ['Wattage Calculator', r.wattage],
              ['Power Supply Buying Guide', r.powerBuying],
              ['Ask Product Support', r.contact]
            ]
          )
        ),

        q(
          'strip-controller',
          'LED strip + controller',
          d(
            'Control compatibility',
            'Review the control path',
            'The controller needs to match the lighting type, system voltage, and control requirements of the project.',
            r.dimmingGuide,
            'Review controls',
            [
              ['Dimming & Controls Buying Guide', r.dimmingBuying],
              ['Ask Product Support', r.contact]
            ]
          )
        ),

        q(
          'driver-dimmer',
          'Driver + wall dimmer',
          d(
            'Dimming compatibility',
            'Match the driver and dimming method',
            'Driver and dimmer compatibility depends on the supported dimming method and the specific control being used.',
            r.dimmingBuying,
            'Review dimming compatibility',
            [
              ['Dimming & Controls Guide', r.dimmingGuide],
              ['Ask Product Support', r.contact]
            ]
          )
        ),

        q(
          'complete-system',
          'A complete LED system',
          d(
            'Recommended tool',
            'LED System Builder',
            'For a new project, plan the components together rather than validating each choice independently.',
            r.system,
            'Plan a compatible system',
            [
              ['LED System Guide', r.systemGuide],
              ['Ask Product Support', r.contact]
            ]
          )
        )
      ]
    },

    install: {
      kicker: 'Install a System',
      title: 'What are you working on?',
      description: 'Choose the installation task that best matches your question.',
      questions: [
        q(
          'wire-system',
          'How do I wire my LED system?',
          d(
            'Installation guide',
            'Wiring & Connections Guide',
            'Review the relationship between power, controls, wiring, connections, and LED loads before making connections.',
            r.wiringGuide,
            'Review wiring',
            [
              ['Installation Guide', r.installationGuide],
              ['LED System Guide', r.systemGuide]
            ]
          )
        ),

        q(
          'multiple-runs',
          'How do I connect multiple LED runs?',
          d(
            'Wiring resource',
            'Wiring & Connections Guide',
            'Review common connection and run-planning concepts for systems using more than one LED run.',
            r.wiringGuide,
            'Review connections',
            [
              ['System Planning Guide', r.planningGuide],
              ['Wattage Calculator', r.wattage]
            ]
          )
        ),

        q(
          'cut-strip',
          'How do I cut or connect LED strip?',
          d(
            'LED strip guide',
            'LED Strip Lighting Guide',
            'Learn the basic construction and handling concepts that matter when working with LED strip lighting.',
            r.stripGuide,
            'Review LED strip basics',
            [
              ['Wiring & Connections Guide', r.wiringGuide],
              ['Installation Guide', r.installationGuide]
            ]
          )
        ),

        q(
          'install-strip',
          'How should I install LED strip?',
          d(
            'Installation guide',
            'LED Installation Guide',
            'Review preparation, placement, installation, and system-checking considerations before completing the project.',
            r.installationGuide,
            'Review installation',
            [
              ['LED Strip Lighting Guide', r.stripGuide],
              ['Wiring & Connections Guide', r.wiringGuide]
            ]
          )
        ),

        q(
          'outdoor-install',
          'I’m installing in a wet or outdoor location',
          d(
            'Environment guide',
            'IP Ratings & Environment Guide',
            'Check the environmental conditions and required product protection before installation.',
            r.ipGuide,
            'Check the environment',
            [
              ['Installation Guide', r.installationGuide],
              ['Contact Project Support', r.contact]
            ]
          )
        ),

        q(
          'product-instructions',
          'I need instructions for a specific product',
          d(
            'Product documentation',
            'Product Documentation',
            'Browse available specifications, manuals, and downloadable product information.',
            r.docs,
            'Find product documentation',
            [
              ['Contact Product Support', r.contact]
            ]
          )
        )
      ]
    },

    fix: {
      kicker: 'Fix a Problem',
      title: 'Start with what you see.',
      description: 'Choose the symptom that most closely matches what the system is doing.',
      questions: [
        q(
          'no-light',
          'Nothing turns on',
          d(
            'Troubleshooting',
            'Start with the power path',
            'When nothing turns on, begin by checking the system from the power source forward rather than replacing components at random.',
            r.troubleshootingGuide,
            'Troubleshoot no light',
            [
              ['Power & Driver Guide', r.powerGuide],
              ['Wiring & Connections Guide', r.wiringGuide]
            ]
          )
        ),

        q(
          'partial-light',
          'Only part of the strip lights',
          d(
            'Troubleshooting',
            'Troubleshoot partial illumination',
            'A partially illuminated run can point to a connection, strip, wiring, or power-distribution issue.',
            r.troubleshootingGuide,
            'Troubleshoot partial lighting',
            [
              ['Wiring & Connections Guide', r.wiringGuide],
              ['LED Strip Lighting Guide', r.stripGuide]
            ]
          )
        ),

        q(
          'flickering',
          'LEDs are flickering',
          d(
            'Troubleshooting',
            'Troubleshoot flickering',
            'Flickering can involve the power source, control method, system load, wiring, or connections. Preserve the clues before changing components.',
            r.troubleshootingGuide,
            'Troubleshoot flickering',
            [
              ['Dimming & Controls Guide', r.dimmingGuide],
              ['Power & Driver Guide', r.powerGuide]
            ]
          )
        ),

        q(
          'dim',
          'LEDs look dim',
          d(
            'Troubleshooting',
            'Troubleshoot dim output',
            'Unexpectedly dim output can involve system voltage, load, wiring, controls, or the lighting product itself.',
            r.troubleshootingGuide,
            'Troubleshoot dim output',
            [
              ['Power & Driver Guide', r.powerGuide],
              ['Wiring & Connections Guide', r.wiringGuide]
            ]
          )
        ),

        q(
          'end-dimmer',
          'One end of the run is dimmer',
          d(
            'Troubleshooting',
            'Check the run and power path',
            'Brightness changing along a run can be related to voltage drop, run length, wiring, or where power enters the system.',
            r.troubleshootingGuide,
            'Troubleshoot the run',
            [
              ['System Planning Guide', r.planningGuide],
              ['Wiring & Connections Guide', r.wiringGuide]
            ]
          )
        ),

        q(
          'control-problem',
          'Dimmer, controller, or remote isn’t working correctly',
          d(
            'Troubleshooting',
            'Check the control path',
            'Control problems can involve compatibility, pairing, wiring, power, or the control method being used.',
            r.troubleshootingGuide,
            'Troubleshoot controls',
            [
              ['Dimming & Controls Guide', r.dimmingGuide],
              ['Contact Product Support', r.contact]
            ]
          )
        )
      ]
    },

    product: {
      kicker: 'Product Help',
      title: 'What kind of product help do you need?',
      description: 'Find product-specific information or get help with a product you already have.',
      questions: [
        q(
          'documentation',
          'I need a spec sheet, manual, or product document',
          d(
            'Product documentation',
            'Resource Downloads',
            'Browse the currently available product specifications, manuals, and downloadable documentation.',
            r.docs,
            'Browse documentation',
            [
              ['Product Selection Hub', r.productHub],
              ['Contact Product Support', r.contact]
            ]
          )
        ),

        q(
          'identify-product',
          'I have a product question',
          d(
            'Product support',
            'Contact Product Support',
            'Send us the product or model information along with your question so we can help point you in the right direction.',
            r.contact,
            'Contact product support',
            [
              ['Product Documentation', r.docs],
              ['FAQ', r.faq]
            ]
          )
        ),

        q(
          'choose-replacement',
          'I’m trying to choose or replace a component',
          d(
            'Product selection',
            'Start with Product Selection',
            'Use the product-selection resources to narrow the component type before comparing individual products.',
            r.productHub,
            'Choose a product',
            [
              ['System Builder', r.system],
              ['Contact Product Support', r.contact]
            ]
          )
        )
      ]
    }
  };

  /* ---------------------------------------------------------
     SUPPORT SEARCH INDEX
  --------------------------------------------------------- */

  var search = [
    {
      type: 'Contact Support',
      title: 'Contact Emitever',
      copy: 'Send us your question, project details, or order information through our Contact page.',
      keywords: 'contact contact us support customer service phone phone number number call call us telephone email email address talk to someone speak to someone reach us',
      url: r.contact,
      action: 'Contact Support'
    },

    {
      type: 'Quick Answer',
      title: 'Shipping times & costs',
      copy: 'U.S. orders are typically processed in 1-2 business days. Estimated transit after shipment is 3-10 business days. Standard shipping is $10 under $100 and free for orders of $100 or more.',
      keywords: 'shipping ship delivery delivery time shipping time shipping cost shipping costs shipping price shipping rate rates free shipping standard shipping how much is shipping how long does shipping take when will my order arrive processing time transit time delivery estimate',
      url: r.shippingPolicy,
      action: 'View shipping policy',
      kind: 'answer',
      boost: 80,
      requires: 'shipping ship delivery transit arrival processing'
    },

    {
      type: 'Shipping Policy',
      title: 'Shipping Policy',
      copy: 'Review shipping costs, processing and delivery estimates, U.S. fulfillment, tracking, international shipping, customs, and shipment claims.',
      keywords: 'shipping policy delivery policy fulfillment policy shipment policy shipping rules delivery rules carrier tracking international shipping customs duties taxes restrictions',
      url: r.shippingPolicy,
      action: 'View shipping policy',
      boost: 60
    },

    {
      type: 'Quick Answer',
      title: 'Tracking & shipment updates',
      copy: 'Tracking information is sent after dispatch when available and may take up to 24 hours to become active. You can also sign in to review your Emitever.com order details.',
      keywords: 'track tracking tracking number shipment status package status where is my order where is my package order tracking delivery tracking shipped dispatched tracking not working',
      url: r.orders,
      action: 'View my orders',
      kind: 'answer',
      boost: 70
    },

    {
      type: 'Quick Answer',
      title: 'Package missing or marked delivered',
      copy: 'If tracking says delivered but the package is missing, first check the delivery location, household members, neighbors, building staff, and any carrier proof of delivery. Emitever can review available tracking and assist with the appropriate carrier or fulfillment process.',
      keywords: 'missing package package missing marked delivered not received says delivered delivered but not received stolen package lost package lost shipment delivery scan porch theft carrier delivered missing order',
      url: r.shippingPolicy,
      action: 'Review shipping policy',
      kind: 'answer',
      boost: 75,
      requires: 'missing delivered lost stolen theft package'
    },

    {
      type: 'Quick Answer',
      title: 'International shipping & customs',
      copy: 'International shipping may be available for selected destinations when offered at checkout. Applicable customs duties, taxes, import fees, brokerage fees, and clearance charges are the customer responsibility.',
      keywords: 'international shipping ship internationally overseas shipping worldwide shipping customs duty duties taxes import fees brokerage clearance country destination outside united states canada europe uk',
      url: r.shippingPolicy,
      action: 'View international shipping terms',
      kind: 'answer',
      boost: 70,
      requires: 'international customs duty duties tax taxes import overseas worldwide outside country destination'
    },

    {
      type: 'Quick Answer',
      title: '30-day return window',
      copy: 'Returns for eligible Emitever.com purchases are accepted within 30 days of delivery. Items must meet the condition requirements in the Return & Refund Policy and require prior authorization.',
      keywords: 'return window how long do i have to return 30 day 30 days returns return period return deadline eligible return can i return return eligibility',
      url: r.returnsPolicy,
      action: 'View return policy',
      kind: 'answer',
      boost: 80,
      requires: 'return returns 30 window deadline eligible eligibility'
    },

    {
      type: 'Quick Answer',
      title: 'How long do refunds take?',
      copy: 'After an authorized return is received and inspected, approved refunds are typically processed within about 2 business days. Your financial institution may take an additional 5-7 business days to post the refund.',
      keywords: 'refund time refund timing how long refund how long does refund take money back when will i get refund refund pending refund processing refund processed 5 7 business days 2 business days',
      url: r.returnsPolicy,
      action: 'View refund terms',
      kind: 'answer',
      boost: 85,
      requires: 'refund refunds money reimbursement pending'
    },

    {
      type: 'Quick Answer',
      title: 'Return shipping costs',
      copy: 'Customers are responsible for return shipping costs for standard approved returns unless a different resolution is approved for a damaged, defective, or incorrect order.',
      keywords: 'return shipping return shipping cost who pays return shipping return label prepaid label free returns return postage shipping back send it back cost to return',
      url: r.returnsPolicy,
      action: 'View return policy',
      kind: 'answer',
      boost: 75,
      requires: 'return returns label prepaid postage send back'
    },

    {
      type: 'Quick Answer',
      title: 'Exchanges',
      copy: 'Emitever does not currently offer direct product exchanges as part of the standard return process. Contact support about return eligibility, then place a separate order for the desired product.',
      keywords: 'exchange exchanges swap replace for different item change product exchange item exchange size exchange color direct exchange do you do exchanges',
      url: r.returnsPolicy,
      action: 'View return & refund policy',
      kind: 'answer',
      boost: 80,
      requires: 'exchange exchanges swap different item change product'
    },

    {
      type: 'Privacy Policy',
      title: 'Privacy Policy',
      copy: 'Learn what personal information Emitever.com may collect or process, how it is used and disclosed, how cookies and advertising technologies may be used, and what privacy choices may apply to you.',
      keywords: 'privacy privacy policy personal information personal data data policy information collection data collection security retention shopify privacy cookies advertising tracking targeted ads',
      url: r.privacyPolicy,
      action: 'View privacy policy',
      boost: 75
    },

    {
      type: 'Quick Answer',
      title: 'Privacy requests & data rights',
      copy: 'Depending on where you live, you may have rights to request access, deletion, correction, portability, or certain advertising opt-outs. Requests can be made through the available privacy controls or by contacting Emitever support.',
      keywords: 'delete my data delete information privacy request access my data personal data request correct my data correction portability opt out sale sharing targeted advertising privacy rights remove my information do not sell',
      url: r.privacyPolicy,
      action: 'Review privacy rights',
      kind: 'answer',
      boost: 80,
      requires: 'delete deletion remove access correction correct portability rights request requests opt out sale sharing targeted'
    },

    {
      type: 'Quick Answer',
      title: 'Cookies, analytics & advertising',
      copy: 'Emitever.com and service providers may use cookies and similar technologies for site functionality, preferences, security, analytics, performance measurement, and relevant advertising. Available controls depend on your location and browser.',
      keywords: 'cookies cookie tracking analytics advertising ads pixel pixels google analytics meta ads tracking technologies targeted advertising browser cookies marketing privacy',
      url: r.privacyPolicy,
      action: 'View privacy policy',
      kind: 'answer',
      boost: 70,
      requires: 'cookie cookies analytics advertising ads pixel pixels tracking'
    },

    {
      type: 'Terms of Service',
      title: 'Terms of Service',
      copy: 'Review the terms that apply to using Emitever.com, purchases, account information, products, third-party services, permitted use, liability, and other legal conditions.',
      keywords: 'terms terms of service terms and conditions conditions legal legal terms website terms purchase terms rules governing law hong kong law liability warranty indemnification prohibited use',
      url: r.termsPolicy,
      action: 'View terms of service',
      boost: 80
    },

    {
      type: 'Business Information',
      title: 'Who operates Emitever.com?',
      copy: 'Emitever.com is operated by CUTELED LIGHT CO., LIMITED under the EMITEVER brand. The Hong Kong address shown in our legal policies is the registered corporate office and is not a shipping, fulfillment, or return address.',
      keywords: 'who owns emitever who operates emitever company legal company business name cuteled cuteled light co limited emitever company address registered office hong kong business identity corporate office legal entity',
      url: r.termsPolicy,
      action: 'View business terms',
      kind: 'answer',
      boost: 70,
      requires: 'company business legal address owner owns operate operates operator cuteled who'
    },

    {
      type: 'Returns & Refunds',
      title: 'Return an Emitever.com Purchase',
      copy: 'For purchases made directly through Emitever.com, review our return policy and contact us to start the return process.',
      keywords: 'return returns refund refunds send back return item return order emitever return website return direct order',
      url: r.orderSupport,
      action: 'Start an Emitever.com return'
    },

    {
      type: 'Amazon Returns',
      title: 'Return an Amazon Purchase',
      copy: 'For products purchased through Amazon, start the return from your Amazon order to receive the return options and instructions available for your purchase.',
      keywords: 'amazon return amazon returns return amazon amazon refund amazon purchase return amazon order return return item send back',
      url: r.amazonReturns,
      action: 'Start an Amazon return'
    },

    {
      type: 'Returns Policy',
      title: 'Emitever Return Policy',
      copy: 'Review eligibility, timing, shipping responsibilities, and other terms for returns of direct Emitever.com purchases.',
      keywords: 'return policy returns policy refund policy return window 30 days shipping return address eligibility',
      url: r.returnsPolicy,
      action: 'View return policy'
    },

    {
      type: 'Education',
      title: 'Education Lighting Solutions',
      copy: 'Explore lighting resources for schools, classrooms, facilities, retrofits, and education projects.',
      keywords: 'education educational school schools classroom classrooms k12 k-12 facility facilities campus retrofit education lighting school lighting learning educational resources',
      url: '/pages/education-lighting-solutions',
      action: 'Explore education solutions'
    },

    {
      type: 'Education Resource',
      title: 'Education Funding & Incentives',
      copy: 'Explore grants, rebates, utility incentives, financing, and funding resources for school lighting projects.',
      keywords: 'education educational school funding grant grants rebate rebates incentive incentives utility financing doe renew america schools facility upgrade',
      url: '/pages/edu-resource-hub',
      action: 'Explore funding resources'
    },

    {
      type: 'Planning Resource',
      title: 'Education Project Checklist',
      copy: 'Use a printable checklist to gather site, electrical, control, and project information for education lighting projects.',
      keywords: 'education educational school checklist facility checklist site survey planning checklist project checklist classroom campus',
      url: '/pages/edu-checklist-download',
      action: 'Open education checklist'
    },

    {
      type: 'Application',
      title: 'School Lighting Projects',
      copy: 'Explore lighting ideas and product paths for dorm, bedroom, study, and school-related spaces.',
      keywords: 'school lighting projects dorm dormitory study bedroom student campus back to school education educational',
      url: '/pages/school-lighting-projects',
      action: 'Explore school projects'
    },

    {
      type: 'Blog',
      title: 'LED Strip Lighting Knowledge Hub',
      copy: 'Browse articles about LED strip systems, planning, installation, power, controls, and product selection.',
      keywords: 'blog blogs article articles knowledge hub learn learning education resources led strip blog guides how to news technical articles',
      url: '/blogs/led-strip-lighting-knowledge-hub',
      action: 'Browse knowledge articles'
    },

    {
      type: 'News & Articles',
      title: 'EMITEVER Updates & Articles',
      copy: 'Browse EMITEVER news, product explainers, technical articles, and lighting updates.',
      keywords: 'news update updates blog blogs article articles latest emitever news lighting news industry updates technical articles',
      url: '/blogs/news',
      action: 'Browse news and articles'
    },

    {
      type: 'Learning Guides',
      title: 'LED Learning Guides',
      copy: 'Start with the LED System Guide and continue into planning, strips, power, controls, wiring, installation, IP ratings, and troubleshooting.',
      keywords: 'learning guides learn education educational technical guides guides resources how led works system guide planning guide wiring guide installation guide troubleshooting guide',
      url: r.systemGuide,
      action: 'Browse learning guides'
    },

    {
      type: 'Buying Guides',
      title: 'LED Buying Guides',
      copy: 'Start with LED strip selection, then use the power and dimming buying guides to choose compatible system components.',
      keywords: 'buying guides purchasing guides purchase guide shopping guide how to buy selection guides choose products strip buying power buying dimming buying',
      url: r.stripBuying,
      action: 'Browse buying guides'
    },

    {
      type: 'Application',
      title: 'Lighting Application Hub',
      copy: 'Browse lighting paths for residential, commercial, architectural, outdoor, and wet-location projects.',
      keywords: 'application applications residential commercial architectural outdoor wet location space lighting project type',
      url: '/pages/lighting-application-hub',
      action: 'Browse applications'
    },

    {
      type: 'Product Selection',
      title: 'Product Selection Hub',
      copy: 'Browse EMITEVER product families and choose a path based on the part of the system you need.',
      keywords: 'products product selection categories lineup browse products what products do you sell led lighting family',
      url: r.productHub,
      action: 'Browse products'
    },

    {
      type: 'Troubleshooting',
      title: 'LED Troubleshooting Guide',
      copy: 'Diagnose flickering, no light, dim output, shutdowns, and other common LED system symptoms.',
      keywords: 'flicker flickering flashing blinking no light wont turn on not working broken dim too dim shutdown troubleshooting problem issue',
      url: r.troubleshootingGuide,
      action: 'Open troubleshooting guide'
    },

    {
      type: 'Article',
      title: 'MLV vs ELV',
      copy: 'Understand magnetic low-voltage and electronic low-voltage dimming terminology, including leading-edge and trailing-edge control.',
      keywords: 'mlv elv magnetic low voltage electronic low voltage leading edge trailing edge dimmer dimming',
      url: '/blogs/news/mlv-vs-elv',
      action: 'Read MLV vs ELV'
    },

    {
      type: 'Article',
      title: '24V vs 48V LED Strip Systems',
      copy: 'Compare 24V and 48V systems, run length, voltage drop, and when each architecture makes sense.',
      keywords: '24v vs 48v 24 volt vs 48 volt which voltage voltage drop long run run length choose voltage power injection dim at end',
      url: '/blogs/led-strip-lighting-knowledge-hub/24v-vs-48v-led-strip-systems',
      action: 'Read 24V vs 48V guide'
    },

    {
      type: 'Technical Guide',
      title: 'Dimming & Controls Guide',
      copy: 'Understand phase-cut, TRIAC, ELV, MLV, 0-10V, PWM, controllers, dimmers, and control compatibility.',
      keywords: 'switch dimmer wall switch controller dimming triac elv mlv phase cut phase-cut 0-10v 0 10v pwm remote control controls compatible dimmable',
      url: r.dimmingGuide,
      action: 'Open dimming guide'
    },

    {
      type: 'Buying Guide',
      title: 'How to Buy Dimming & Controls',
      copy: 'Choose a control method that matches the lighting and driver in your system.',
      keywords: 'switch dimmer controller choose dimmer buy dimmer wall dimmer remote rf wifi rgb rgbw tunable white cct',
      url: r.dimmingBuying,
      action: 'Open buying guide'
    },

    {
      type: 'Technical Guide',
      title: 'IP Ratings & Environment Guide',
      copy: 'Understand dry, damp, wet, outdoor, waterproof, and IP-rated installation environments.',
      keywords: 'waterproof water resistant wet damp outdoor outside bathroom kitchen moisture weather ip ip54 ip65 ip67 ip68 environment',
      url: r.ipGuide,
      action: 'Open IP guide'
    },

    {
      type: 'Technical Guide',
      title: 'Wiring & Connections Guide',
      copy: 'Learn about wiring, connections, multiple runs, RGB/RGBW channels, and system power paths.',
      keywords: 'wire wiring connect connection connector series parallel multiple strips multiple runs rgb rgbw 4 wire four wire power injection power feed topology',
      url: r.wiringGuide,
      action: 'Open wiring guide'
    },

    {
      type: 'Technical Guide',
      title: 'LED Installation Guide',
      copy: 'Review the installation workflow, preparation, bench testing, mounting, routing, and final checks.',
      keywords: 'install installation mounting mount setup bench test cut cutting led strip install strip',
      url: r.installationGuide,
      action: 'Open installation guide'
    },

    {
      type: 'Planning Tool',
      title: 'LED Wattage Calculator',
      copy: 'Calculate connected LED load and estimate the power capacity required for the installation.',
      keywords: 'wattage watts power sizing power supply size driver size transformer size calculator calculate load 20 percent headroom',
      url: r.wattage,
      action: 'Open calculator'
    },

    {
      type: 'Planning Tool',
      title: 'LED System Builder',
      copy: 'Plan lighting, power, controls, and compatible components as a complete system.',
      keywords: 'system builder compatibility compatible components complete system plan project professional builder',
      url: r.system,
      action: 'Open System Builder'
    },

    {
      type: 'Planning',
      title: 'LED System Planning Guide',
      copy: 'Plan voltage, runs, zones, power locations, and other system requirements before installation.',
      keywords: 'plan planning voltage drop long run power injection zones runs 24v 48v project design',
      url: r.planningGuide,
      action: 'Open planning guide'
    },

    {
      type: 'Product Documentation',
      title: 'Resource Downloads',
      copy: 'Find EMITEVER spec sheets, manuals, installation guides, certificates, and technical documents by product family and model.',
      keywords: 'manual spec specs specification spec sheet specsheet datasheet data sheet pdf documentation document download certificate compliance installation guide model sku pwr g24v g48v 24v driver 48v driver cob smd connector power adapter',
      url: r.docs,
      action: 'Browse documentation'
    },

    {
      type: 'Reference',
      title: 'EMITEVER Product Catalog',
      copy: 'Browse the current EMITEVER product lineup in the downloadable product catalog.',
      keywords: 'catalog catalogue brochure full lineup product catalog product list pdf catalog',
      url: r.catalog,
      action: 'View product catalog'
    },

    {
      type: 'Product Selection',
      title: 'LED Strip Light Buying Guide',
      copy: 'Compare strip-light characteristics and narrow the right lighting type for a project.',
      keywords: 'strip led strip cob smd rgb rgbw tunable white cct color temperature kelvin cri choose strip buy strip strip width',
      url: r.stripBuying,
      action: 'Open strip buying guide'
    },

    {
      type: 'Product Selection',
      title: 'Power Supply & Driver Buying Guide',
      copy: 'Choose power by voltage, load, dimming method, environment, and installation requirements.',
      keywords: 'power supply driver transformer choose power 24v 48v wattage dimmable non dimmable universal driver',
      url: r.powerBuying,
      action: 'Open power buying guide'
    },

    {
      type: 'Technical Guide',
      title: 'LED Power & Driver Guide',
      copy: 'Understand driver voltage, load sizing, dimming architecture, and power-system requirements.',
      keywords: 'power driver power supply transformer 24v 48v voltage wattage load universal driver dimmable driver',
      url: r.powerGuide,
      action: 'Open power guide'
    },

    {
      type: 'Technical Guide',
      title: 'LED Strip Lighting Guide',
      copy: 'Understand strip types, voltage, light quality, cutting, and other LED strip fundamentals.',
      keywords: 'led strip strip lights tape tape light led tape cob smd rgb rgbw cct cri kelvin cut cutting voltage 24v 48v',
      url: r.stripGuide,
      action: 'Open strip guide'
    },

    {
      type: 'Professional',
      title: 'Lighting & Power Professionals Hub',
      copy: 'Specify products, plan systems, purchase for projects, access technical resources, and explore professional purchasing.',
      keywords: 'professional professionals contractor electrician installer architect specifier engineer commercial project b2b trade project purchasing technical resources specification specify',
      url: r.professionals,
      action: 'Open Professionals Hub'
    },

    {
      type: 'Project Purchasing',
      title: 'Request Project Pricing',
      copy: 'For larger quantities or project purchasing requirements that need review.',
      keywords: 'bulk order large order volume quote project pricing quote pricing quantities 100 drivers purchasing project purchase',
      url: r.projectPricing,
      action: 'Request project pricing'
    },

    {
      type: 'Professional',
      title: 'EMITEVER Partners',
      copy: 'Apply for ongoing professional and wholesale purchasing benefits.',
      keywords: 'partner partners wholesale dealer reseller distributor b2b trade account contractor pricing ongoing purchasing wholesale account become partner',
      url: r.partners,
      action: 'Explore Partner Program'
    },

    {
      type: 'Order Support',
      title: 'View My Emitever.com Orders',
      copy: 'Sign in to view your Emitever.com order history and order details.',
      keywords: 'my order check my order order status latest order recent order track tracking shipment package delivery purchase order history emitever order',
      url: r.orders,
      action: 'View my orders'
    },

    {
      type: 'Order Support',
      title: 'Contact Emitever.com Order Support',
      copy: 'Send us details about an order placed directly through Emitever.com.',
      keywords: 'order support emitever order wrong item damaged order cancel order change order missing package delivery problem',
      url: r.orderSupport,
      action: 'Contact order support'
    },

    {
      type: 'Amazon Support',
      title: 'Amazon Order / Product Support',
      copy: 'Get product or order support for an EMITEVER purchase made through Amazon.',
      keywords: 'amazon amazon order amazon purchase amazon product asin bought on amazon amazon support',
      url: r.amazonSupport,
      action: 'Contact Amazon support'
    },

    {
      type: 'FAQ',
      title: 'Frequently Asked Questions',
      copy: 'Quick answers covering orders, power supplies, LED strips, controls, terminology, and common questions.',
      keywords: 'faq frequently asked questions question answer help lumens ma color temperature remote not working shipping',
      url: r.faq,
      action: 'Browse FAQ'
    },

    {
      type: 'Product Help',
      title: 'Contact Product Support',
      copy: 'Send us the product or model information and your question for additional help.',
      keywords: 'product help product support model help compatibility help contact support talk to someone',
      url: r.contact + '?inquiry=product_help',
      action: 'Contact product support'
    }
  ];

  /* ---------------------------------------------------------
     ROUTER ELEMENTS
  --------------------------------------------------------- */

  var router = root.querySelector('[data-emit-support-router]');
  var content = root.querySelector('[data-emit-support-router-content]');
  var buttons = [].slice.call(
    root.querySelectorAll('[data-emit-support-intent]')
  );
  var input = root.querySelector('[data-emit-support-search-input]');
  var results = root.querySelector('[data-emit-support-search-results]');
  var clear = root.querySelector('[data-emit-support-search-clear]');
  var wrap = root.querySelector('[data-emit-support-search]');
  var submit = root.querySelector('[data-emit-support-search-submit]');
  var popular = root.querySelector('.esc-popular');
  var active = null;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[c];
    });
  }

  function setActive(k) {
    active = k;

    buttons.forEach(function (b) {
      var on = b.dataset.emitSupportIntent === k;

      b.classList.toggle('is-active', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function closeRouter() {
    active = null;
    router.hidden = true;
    content.innerHTML = '';

    buttons.forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function renderIntent(k, scroll) {
    var i = intents[k];
    if (!i) return;

    setActive(k);

    content.innerHTML =
      '<div class="esc-router__top">' +
        '<div class="esc-router__heading">' +
          '<span class="esc-router__kicker">' + esc(i.kicker) + '</span>' +
          '<h3>' + esc(i.title) + '</h3>' +
          '<p>' + esc(i.description) + '</p>' +
        '</div>' +
        '<button class="esc-router__close" type="button" data-emit-support-router-close aria-label="Close support options">×</button>' +
      '</div>' +

      '<div class="esc-router-list">' +
        i.questions.map(function (x) {
          return (
            '<button class="esc-router-choice" type="button" data-emit-support-question="' +
            esc(x.id) +
            '">' +
              '<span>' + esc(x.label) + '</span>' +
              '<span>→</span>' +
            '</button>'
          );
        }).join('') +
      '</div>' +

      '<div class="esc-router__footer">' +
        'Something else? <a href="' + r.contact + '">Contact Support →</a>' +
      '</div>';

    router.hidden = false;

    if (scroll) {
      requestAnimationFrame(function () {
        router.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }
  }

  function findQ(k, id) {
    return intents[k].questions.find(function (x) {
      return x.id === id;
    });
  }

  function renderDest(k, id, scroll) {
    var i = intents[k];
    var x = findQ(k, id);

    if (!i || !x) return;

    setActive(k);

    var z = x.destination;

    var rel = z.related.map(function (a) {
      return (
        '<a class="esc-related-link" href="' + esc(a[1]) + '">' +
          '<span>' + esc(a[0]) + '</span>' +
          '<span>→</span>' +
        '</a>'
      );
    }).join('');

    content.innerHTML =
      '<button class="esc-router-back" type="button" data-emit-support-router-back="' +
      k +
      '">← ' +
      esc(i.kicker) +
      '</button>' +

      '<div class="esc-router__top">' +
        '<div class="esc-router__heading">' +
          '<span class="esc-router__kicker">' + esc(i.kicker) + '</span>' +
          '<h3>' + esc(x.label) + '</h3>' +
        '</div>' +
        '<button class="esc-router__close" type="button" data-emit-support-router-close>×</button>' +
      '</div>' +

      '<div class="esc-destination">' +
        '<div class="esc-destination__primary">' +
          '<span class="esc-destination__label">' + esc(z.label) + '</span>' +
          '<h4>' + esc(z.title) + '</h4>' +
          '<p>' + esc(z.copy) + '</p>' +
          '<a class="esc-button esc-button--dark" href="' + esc(z.url) + '">' +
            esc(z.action) +
            ' →' +
          '</a>' +
        '</div>' +

        '<div class="esc-destination__related">' +
          '<h4>Related resources</h4>' +
          rel +
        '</div>' +
      '</div>' +

      '<div class="esc-router__footer">' +
        'Still having trouble? <a href="' + r.contact + '">Contact Support →</a>' +
      '</div>';

    router.hidden = false;

    if (scroll) {
      router.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.dataset.emitSupportIntent;

      if (active === k && !router.hidden) {
        closeRouter();
      } else {
        renderIntent(k, true);
      }
    });
  });

  router.addEventListener('click', function (e) {
    var closeButton = e.target.closest('[data-emit-support-router-close]');
    var backButton = e.target.closest('[data-emit-support-router-back]');
    var question = e.target.closest('[data-emit-support-question]');

    if (closeButton) {
      closeRouter();
    } else if (backButton) {
      renderIntent(
        backButton.dataset.emitSupportRouterBack,
        false
      );
    } else if (question && active) {
      renderDest(
        active,
        question.dataset.emitSupportQuestion,
        false
      );
    }
  });

  /* ---------------------------------------------------------
     SEARCH
  --------------------------------------------------------- */

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function closeSearch() {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  function scoreSearch(item, query) {
    var title = norm(item.title);
    var keys = norm(item.keywords);
    var copy = norm(item.copy);

    var stopWords = ['a', 'an', 'and', 'are', 'do', 'does', 'for', 'from', 'i', 'in', 'is', 'it', 'my', 'of', 'on', 'or', 'the', 'to', 'we', 'what', 'when', 'where', 'who', 'with'];
    var words = query
      .split(' ')
      .filter(function (w) {
        return w.length > 1 && stopWords.indexOf(w) === -1;
      });

    if (item.requires) {
      var required = norm(item.requires);
      var requiredWords = required.split(' ');
      var requirementMatched = required.indexOf(query) >= 0 || words.some(function (w) {
        return requiredWords.indexOf(w) >= 0;
      });

      if (!requirementMatched) return 0;
    }

    var score = 0;

    if (title === query) score += 120;
    if (title.indexOf(query) >= 0) score += 70;
    if (keys.indexOf(query) >= 0) score += 55;
    if (copy.indexOf(query) >= 0) score += 25;

    words.forEach(function (w) {
      if (title.split(' ').indexOf(w) >= 0) {
        score += 18;
      } else if (title.indexOf(w) >= 0) {
        score += 10;
      }

      if (keys.split(' ').indexOf(w) >= 0) {
        score += 14;
      } else if (keys.indexOf(w) >= 0) {
        score += 7;
      }

      if (copy.indexOf(w) >= 0) {
        score += 3;
      }
    });

    if (score > 0 && item.boost) {
      score += Number(item.boost) || 0;
    }

    return score;
  }

  function renderSearch(v) {
    var query = norm(v);

    clear.hidden = !query;

    if (query.length < 2) {
      closeSearch();
      return;
    }

    var hits = search
      .map(function (item, index) {
        return {
          item: item,
          index: index,
          score: scoreSearch(item, query)
        };
      })
      .filter(function (x) {
        return x.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score || a.index - b.index;
      })
      .slice(0, 6);

    if (!hits.length) {
      results.innerHTML =
        '<div class="esc-search-empty">' +
          '<strong>No close match yet.</strong>' +
          '<p>Try a broader term, browse the FAQ, or send us the details.</p>' +
          '<a class="esc-button esc-button--dark" href="' +
          r.contact +
          '">Contact Support</a> ' +
          '<a class="esc-button esc-button--outline" href="' +
          r.faq +
          '">Browse FAQ</a>' +
        '</div>';
    } else {
      results.innerHTML = hits
        .map(function (hit) {
          var x = hit.item;

          var resultClass = 'esc-search-result esc-search-result--link';
          if (x.kind === 'answer') resultClass += ' esc-search-result--answer';

          return (
            '<a class="' + resultClass + '" href="' +
            esc(x.url) +
            '">' +
              '<span class="esc-search-result__type">' +
                esc(x.type) +
              '</span>' +
              '<strong>' +
                esc(x.title) +
              '</strong>' +
              '<p>' +
                esc(x.copy) +
              '</p>' +
              '<span class="esc-search-result__action">' +
                esc(x.action) +
                ' →' +
              '</span>' +
            '</a>'
          );
        })
        .join('');
    }

    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  input.addEventListener('input', function () {
    renderSearch(input.value);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      renderSearch(input.value);
    }
  });

  if (submit) {
    submit.addEventListener('click', function (e) {
      e.preventDefault();
      renderSearch(input.value);
      input.focus();
    });
  }

  clear.addEventListener('click', function () {
    input.value = '';
    clear.hidden = true;
    closeSearch();
    input.focus();
  });

  document.addEventListener('click', function (e) {
    if (
      !wrap.contains(e.target) &&
      !(popular && popular.contains(e.target))
    ) {
      closeSearch();
    }
  });

  root
    .querySelectorAll('[data-emit-support-query]')
    .forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        input.value = b.dataset.emitSupportQuery;
        renderSearch(input.value);
        input.focus();
      });
    });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (!results.hidden) {
        closeSearch();
        input.focus();
      } else if (!router.hidden) {
        closeRouter();
      }
    }
  });
})();